import { ApiError } from "@/types/api";
import { db } from "@/firebase";
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "@/store/store";
import { setDoc, doc } from "firebase/firestore";
import { pickBy } from "lodash";

export const userOrgOrdersApi = createApi({
  reducerPath: "userOrgOrders",
  baseQuery: fakeBaseQuery<ApiError>(),
  tagTypes: ["userOrders"],
  endpoints: (builder) => ({
    addUserOrgOrder: builder.mutation({
      queryFn: async (
        {
          userId,
          organizationId,
          orderId,
          subtotal,
          total,
        }: {
          userId: string;
          organizationId: string;
          orderId: string;
          subtotal: number;
          total: number;
        }, {
            getState
        }
      ) => {
        try {
          const { auth } = getState() as RootState;

          if (!userId || !organizationId) {
            return {
              error: {
                status: 400,
                message: "Consulta inválida",
              },
            };
          }
          const userOrdersRef = doc(db, `users/${userId}/orders/${orderId}`);
          
          const payload = {
            organizationId,
            createdBy: auth?.user?.uid ? auth?.user?.uid : userId ?? null,
            orderedAt: Date.now(),
            subtotal,
            total,
          };

          await setDoc(userOrdersRef, pickBy(payload, v => v !== undefined));

          return {
            data: {
              userId,
              organizationId,
              orderId,
            },
          };
        } catch (error) {
          console.error(error);
          return {
            error: {
              status: 500,
              message: "Error al guardar la orden",
            },
          };
        }
      },
      invalidatesTags: ["userOrders"],
    }),
  }),
});

export const { useAddUserOrgOrderMutation } = userOrgOrdersApi;

